export default __webpack_public_path__ + "static/media/rangerhead.978f4723.png";